'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundServer = undefined;

var _NotFoundServer2 = require('./NotFoundServer');

var _NotFoundServer3 = _interopRequireDefault(_NotFoundServer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NotFoundServer = _NotFoundServer3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFoundServer/index.jsx
// module id = 1819
// module chunks = 0